import { fetchCaptcha } from '../../../actions/captcha-actions';

export const captchaConfirmationModalDataLoader = () => dispatch => dispatch(fetchCaptcha());
